<form [formGroup]="form" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" type="submit" class="btn btn-outline-success" (click)="guardarAlegacion()"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
            <button [disabled]="!habilitarNuevoDocumento" class="btn btn-outline-success" type="button" (click)="onAdd()"><i class="fa fa-file-o"></i> Nuevo Documento </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">

        <h4 style="display:inline">Alegaciones {{alegacionEx.CodigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitudEx}}" />
                <!--<img class="asignada-icono" src="{{ null | IconoSolicitudAsignada}}" />-->
                <label class="codigo-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitudEx}}">{{alegacionEx.CodigoTipoSolicitud}}</label>
                <img class="estado-icono-big" container="body" src="{{alegacionEx.IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" ngbTooltip="{{alegacionEx.IdEstadoSolicitudExDescripcion}}" />
                <img *ngIf="alegacionEx?.IdSubTipoSolicitudEx === tercerPaisConAtestFito || alegacionEx?.IdSubTipoSolicitudEx === reExpConAtestFito || alegacionEx?.IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{alegacionEx.IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{alegacionEx.IdSubTipoSolicitudExDescripcion}}" />
                <img class="estado-icono-big" container="body" src="{{alegacionEx.IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" ngbTooltip="{{alegacionEx.IdEstadoCertificadoFitoExDescripcion}}" />
                <img *ngIf="alegacionEx?.IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{alegacionEx.IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{alegacionEx.DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <!--ALEGACIONES-->
        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="idSolicitudEx">
                    <app-alertarechazo [id]="idSolicitudEx" [esExport]="true"></app-alertarechazo>
                </ng-container>

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-header"></div>

                    <div class="card-body-detalle">
                        <div class="row">

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpFecha">Fecha Rechazo Inspección</label>
                                <input formControlName="FechaRechazo" name="FechaRechazo" readonly title="" class="form-control" id="inpDescripcion" value="">
                            </div>

                            <div class="form-group offset-md-3 col-md-3">
                                <label class="col-form-label" for="inpFecha">Fecha Alegación</label>
                                <input formControlName="FechaAlegacion" name="FechaAlegacion" readonly title="" class="form-control" id="inpDescripcion" value="">
                            </div>

                        </div>

                        <div class="row" style="margin-bottom:15px;">

                            <div class="form-group col-md-12">
                                <label class="col-form-label" for="inpCodigo">Observaciones Alegación</label>
                                <textarea style="resize:none" formControlName="ObservacionesAlegacion" maxlength="4000" name="ObservacionesAlegacion" title="" class="form-control" [ngClass]="displayFieldCss('ObservacionesAlegacion')" type="text" value=""></textarea>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('ObservacionesAlegacion','required')">
                                    Observaciones es obligatorio
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--DOCUMENTOS-->
        <div class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">

                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Listado de Documentos
                    </div>

                    <div class="card-body-grid">

                        <p-table #tableSearch autoLayout="true" [value]="documentosAlegaciones"
                                 [columns]="cols" sortField="Fecha" sortOrder="-1"
                                 styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                 [ngClass]="displayGridHidden(documentosAlegaciones)">

                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                        {{col.header}}
                                        <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                <tr>

                                    <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                        <span *ngIf="(col.field!=='Link' && col.field!=='Fecha')">
                                            {{rowData[col.field]}}
                                        </span>
                                        <span *ngIf="col.field==='Fecha'">
                                            {{rowData[col.field] | date:'dd/MM/yyyy'}}
                                        </span>

                                        <div *ngIf="col.field==='Link'" class="btn-group">

                                            <div *ngIf="documentoDescargable">

                                                <button (click)="onDownload(rowData)" type="button" title="Descargar documento" class="btn btn-sm btn-danger">
                                                    <span class="fa fa-download"></span>
                                                </button>
                                            </div>

                                            <!--<div *ngIf="documentoEditable">
                                                <button (click)="onEdit(rowData)" type="button" title="Editar" class="btn btn-sm btn-warning">
                                                    <span class="fa fa-edit"></span>

                                                </button>
                                            </div>
                                            <div *ngIf="!documentoEditable">
                                                <button (click)="onEdit(rowData)" type="button" title="Ver" class="btn btn-sm btn-info">
                                                    <span class="fa fa-search"></span>

                                                </button>
                                            </div>-->

                                            <div *ngIf="documentoBorrable">
                                                <button (click)="onDelete(rowData)" type="button" title="Eliminar" class="btn btn-sm btn-danger">
                                                    <span class="fa fa-remove"></span>

                                                </button>
                                            </div>

                                        </div>

                                    </td>
                                </tr>

                            </ng-template>
                        </p-table>
                        <div *ngIf="numeroDocumentos === 0" class="empty-grid">
                            No hay documentos asociados a la solicitud
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--DECISIÓN-->
        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-header"></div>

                    <div class="card-body-detalle">
                        <div class="row">

                            <div class="form-group col-md-6">
                                <label class="col-form-label" for="inpAceptada">¿Aceptar?</label>
                                <div class="ui-g">
                                    <div class="ui-g-3">
                                        <p-radioButton formControlName="Decision" inputStyleClass="form-control" [ngClass]="displayFieldCss('Decision')" name="Decision" value="S" label="Sí"></p-radioButton>
                                    </div>
                                    <div class="ui-g-3">
                                        <p-radioButton formControlName="Decision" inputStyleClass="form-control" [ngClass]="displayFieldCss('Decision')" name="Decision" value="N" label="NO"></p-radioButton>
                                    </div>
                                </div>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Decision','required')">
                                    Decisión es obligatorio
                                </div>
                            </div>
                            
                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="inpFecha">Fecha Decisión</label>
                                <input formControlName="FechaDecision" name="FechaDecision" readonly title="" class="form-control" id="inpDescripcion" value="">
                            </div>

                        </div>

                        <div class="row" style="margin-bottom:15px;">

                            <div class="form-group col-md-12">
                                <label class="col-form-label" for="inpCodigo">Observaciones Decisión</label>
                                <textarea style="resize:none" formControlName="ObservacionesDecision" maxlength="4000" name="ObservacionesDecision" title="" class="form-control" [ngClass]="displayFieldCss('ObservacionesDecision')" type="text" value=""></textarea>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('ObservacionesDecision','required')">
                                    Observaciones es obligatorio
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</form>
